import { createClient } from "@supabase/supabase-js";

// Website Supabase (newsletter / applications / leads). This client also owns
// the admin's auth session — the console signs in here, and the Shield reads go
// through service-role Edge Functions that verify this session.
//
// The browser only ever holds the anon key. RLS is on with no policies on the
// website tables, so anon reads return nothing; privileged reads are done by
// service-role-backed Edge Functions, never from the client.
const url = import.meta.env.VITE_WEBSITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_WEBSITE_SUPABASE_ANON_KEY;

export const websiteSupabase = createClient(url, anonKey, {
  auth: {
    storage: localStorage,
    storageKey: "qadar-admin.auth",
    persistSession: true,
    autoRefreshToken: true,
    // PKCE puts the recovery/invite token in a `?code=` query param instead of
    // the URL hash, so it survives the Cloudflare Access redirect on the way to
    // /auth/reset.
    flowType: "pkce",
    detectSessionInUrl: true,
  },
});
